export default function parseConfigParams(params: any[] = []) {
  const map: Record<string, string> = {};

  if (!params) return map;

  // backend may return array of { type, value } or similar shapes
  for (const p of params) {
    if (!p) continue;
    const key = p.type || p.name || p.key;
    const value = (p.value !== undefined && p.value !== null) ? p.value : (p.defaultValue ?? p);
    if (key) map[key] = String(value);
  }

  return map;
}

export function getPlaceDefaults(params: any[] = []) {
  const m = parseConfigParams(params as any[]);
  const toNum = (k: string, fallback: number) => {
    const v = Number(m[k]);
    return Number.isFinite(v) ? v : fallback;
  };

  return {
    checkInHour: toNum("CHECK_IN_DEFAULT_HOUR", 14),
    checkInMinute: toNum("CHECK_IN_DEFAULT_MINUTE", 0),
    checkOutHour: toNum("CHECK_OUT_DEFAULT_HOUR", 12),
    checkOutMinute: toNum("CHECK_OUT_DEFAULT_MINUTE", 0),
  };
}
